export default __webpack_public_path__ + "static/media/pokeapi.888baca4.png";